export default __webpack_public_path__ + "static/media/Ascher@3x.6298ea52.png";